<div class="registration">
    <div [ngClass]="{'registration--error-container': service.companyInfoNotFound, hidden: !service.companyInfoNotFound}"
      #companyNotFoundContainer tabindex="-1" autofocus>
      <p tabindex="0" class="error-container-header">
        {{ state.registrationPage.companyError.messageMain }}
      </p>
      <div class="error-container-p" tabindex="0">
        {{ state.registrationPage.companyError.actionMessage }}
      </div>
      <div class="error-container-dealer-info">
        <div tabindex="0">{{ state.registrationPage.companyError.customerServiceName }}</div>
        <div tabindex="0">
          {{ state.registrationPage.companyError.phoneNumber.label }} : {{
          state.registrationPage.companyError.phoneNumber.value }}
        </div>
        <div tabindex="0">
          {{ state.registrationPage.companyError.email.label }} : {{ state.registrationPage.companyError.email.value }}
        </div>
        <div class="contactDealerButton">
          <a class="button" href="mailto:customerservice@toyotatmh.com" target="_top">
            <kng-button [state]="state.contactDealerButton"></kng-button>
          </a>
        </div>
      </div>
    </div>
    <div class="registration--section-1">
      <div class="registration--section">
        <div class="registration--profile-info">
          <div class="registration--bullet-point" tabindex="0">
            {{ state.registrationPage.profileInfo.stepNumber }}
          </div>
          <h2 tabindex="0">{{ state.registrationPage.profileInfo.heading }}</h2>
        </div>
        <div class="registration--section-description" tabindex="0">
          {{ state.registrationPage.profileInfo.description }}
        </div>
      </div>
      <form class="registration--form" [formGroup]="service.profileInformationForm" novalidate>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="fname" tabindex="0">
              {{ state.registrationPage.profileInfo.firstName }}</label>
            <input [ngClass]="{
                    'error-input': validateProfileInformation('firstName')
                  }" type="text" [attr.disabled]="isProfileSectionDisabled()" id="fname" name="fname" maxlength="40" formControlName="firstName" />
          </div>
          <div *ngIf="validateProfileInformation('firstName')" class="registration--pending error-message" role="alert" tabindex="0">
            {{ getRequiredErrorMessage(state.registrationPage.profileInfo.firstName) }}
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="lname" tabindex="0">{{
              state.registrationPage.profileInfo.lastName
              }}</label>
            <input [ngClass]="{
                    'error-input': validateProfileInformation('lastName')
                  }" type="text" [attr.disabled]="isProfileSectionDisabled()" id="lname" name="lname" maxlength="40" formControlName="lastName" />
          </div>
          <div *ngIf="validateProfileInformation('lastName')" class="registration--pending error-message" role="alert" tabindex="0">
            {{ getRequiredErrorMessage(state.registrationPage.profileInfo.lastName) }}
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="email" tabindex="0">{{
              state.registrationPage.profileInfo.emailAddress
              }}</label>
            <input [ngClass]="{ 'error-input': validateProfileInformation('email') }" type="text" id="email" name="email"
              value="first.lastname@email.com" maxlength="50" formControlName="email" />
          </div>
          <div *ngIf="validateProfileInformation('email')" class="registration--pending error-message" role="alert" tabindex="0">
            {{ getRequiredErrorMessage(state.registrationPage.profileInfo.emailAddress) }}
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="phone" tabindex="0">{{
              state.registrationPage.profileInfo.phoneNumber
              }}</label>
            <input [ngClass]="{
                    'error-input': validateProfileInformation('phoneNumber')
                  }" type="tel" id="phone" name="phone" maxlength="13" formControlName="phoneNumber" [attr.disabled]="isProfileSectionDisabled()" #phoneNumber
                  (input)="phoneNumberHandler($event, phoneNumber)"/>
          </div>
          <div *ngIf="validateProfileInformation('phoneNumber')" class="registration--pending error-message" tabindex="0">
            <div *ngIf="
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ] &&
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ]['required']
                  " class="registration--pending error-message" role="alert">
                  {{ getRequiredErrorMessage(state.registrationPage.profileInfo.phoneNumber)  }}
            </div>
            <div *ngIf="
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ] &&
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ]['minLength']
                  " class="registration--pending error-message" role="alert">
                  {{ state.errorText.phoneLength }}
            </div>
            <div *ngIf="
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ] &&
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ]['unique']
                  " class="registration--pending error-message" role="alert">
                  {{state.errorText.phoneSameNumber}}
            </div>
            <div *ngIf="
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ] &&
                    service.profileInformationForm.controls['phoneNumber'][
                      'errors'
                    ]['sequence']
                  " class="registration--pending error-message" role="alert">
                  {{state.errorText.phoneSequenceNumber}}
            </div>
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="title" tabindex="0">{{
              state.registrationPage.profileInfo.jobTitle
              }}</label>
            <div class="desktop-view">
              <mat-select disableOptionCentering panelClass="myPanelClass" yPosition="below" aria-label="job title"
                disableRipple [ngClass]="{
                      'error-input': validateProfileInformation('jobTitle')
                    }" class="form-select" formControlName="jobTitle" name="job title">
                <mat-option *ngFor="let title of state.jobTitle" [value]="title.id">
                  {{ title.label }}
                </mat-option>
              </mat-select>
            </div>
            <div class="mobile-view">
              <select id="jobTitleDropdownMobile" aria-label="job title"
                [ngClass]="{'error-input': validateProfileInformation('jobTitle')}" class="form-select"
                formControlName="jobTitle" name="job title">
                <option *ngFor="let title of state.jobTitle" [value]="title.id">
                  {{ title.label }}
                </option>
              </select>
            </div>
          </div>
          <div *ngIf="validateProfileInformation('jobTitle')" class="registration--pending error-message" role="alert" tabindex="0">
            {{ getRequiredErrorMessage(state.registrationPage.profileInfo.jobTitle, true) }}
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="role" tabindex="0">{{
              state.registrationPage.profileInfo.requestedRole.label
              }}</label>
            <div class="registered-role">
              <div class="desktop-view">
                <mat-select disableOptionCentering panelClass="myPanelClass" yPosition="below" disableRipple
                  class="form-select" aria-label="requested role" formControlName="requestedRole" [ngClass]="{
                        'error-input': validateProfileInformation('requestedRole')
                      }">
                  <mat-option #matOption *ngFor="let role of state.requestedRole" [value]="role.id">
                    {{ role.name}}
                  </mat-option>
                </mat-select>
              </div>
              <div class="mobile-view">
                <select class="form-select" aria-label="requested role" formControlName="requestedRole"
                  [ngClass]="{'error-input': validateProfileInformation('requestedRole')}">
                  <option *ngFor="let role of state.requestedRole" [value]="role.id">
                    {{ role.name}}
                  </option>
                </select>
              </div>
              <div *ngIf="validateProfileInformation('requestedRole')" class="registration--pending error-message" tabindex="0"
                role="alert">
                {{ getRequiredErrorMessage(state.registrationPage.profileInfo.requestedRole.label, true) }}
              </div>
              <p class="registration--pending" tabindex="0">
                {{
                state.registrationPage.profileInfo.requestedRole.description
                }}
              </p>
              <p class="registration--default-user" tabindex="0">
                {{ getRoleDescription(service.profileInformationForm.controls['requestedRole'].value) }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="registration--section-2">
      <div class="registration--section">
        <div class="registration--profile-info">
          <div class="registration--bullet-point" tabindex="0">
            {{ state.registrationPage.companyDetails.stepNumber }}
          </div>
          <h2 tabindex="0">{{ state.registrationPage.companyDetails.heading }}</h2>
        </div>
        <p class="registration--section-description" tabindex="0">
          {{ state.registrationPage.companyDetails.description }}
        </p>
      </div>
      <form class="registration--form" [formGroup]="service.companyDetailsForm" novalidate>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="companyName" tabindex="0">{{
              state.registrationPage.companyDetails.companyName
              }}</label>
            <input [ngClass]="{
                    'error-input': validateCompanyDetails('accountName')
                  }" type="text" id="companyName" name="companyName" maxlength="40" formControlName="accountName"
              (input)="nonNumericSpaceRestriction(service.companyDetailsForm.controls['accountName'].value, 'accountName')"
              [attr.disabled]="isCompanySectionDisabled()"  />
          </div>
          <div class="registration--pending form-warning" *ngIf="accountNameMaxLengthMessage">{{ accountNameMaxLengthMessage }}</div>
          <div
            *ngIf="validateCompanyDetails('accountName') && service.companyDetailsForm.controls['accountName']['errors']"
            class="registration--pending error-message" role="alert" tabindex="0">
            <div *ngIf="service.companyDetailsForm.controls['accountName']['errors']['required']">
              {{ getRequiredErrorMessage(state.registrationPage.companyDetails.companyName) }}
            </div>
            <div *ngIf="service.companyDetailsForm.controls['accountName']['errors']['alphaSpclCharValidationError']">
              {{ state.errorText.invalidCharacterWithNumericErrorMessage }}
            </div>
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="addressLine1" tabindex="0">{{
              state.registrationPage.companyDetails.addressLine1
              }}</label>
            <input [ngClass]="{
                    'error-input': validateCompanyDetails('addressLine1')
                  }" type="text" id="addressLine1" name="addressLine1" maxlength="50" formControlName="addressLine1"
              (input)="inputFormatterCompanyInfo('addressLine1')" [attr.disabled]="isCompanySectionDisabled()" />
          </div>
          <div *ngIf="validateCompanyDetails('addressLine1')" class="registration--pending error-message" role="alert" tabindex="0">
            {{ getRequiredErrorMessage(state.registrationPage.companyDetails.addressLine1) }}
          </div>
        </div>
        <div class="registration--input-group">
          <div class="form-group">
            <label for="addressLine2" tabindex="0">{{
              state.registrationPage.companyDetails.address2OptionalLabel
              }}</label>
            <input type="text" id="addressLine2" name="addressLine2" maxlength="50" formControlName="addressLine2"
              (input)="inputFormatterCompanyInfo('addressLine2')" [attr.disabled]="isCompanySectionDisabled()" />
          </div>
        </div>
        <div class="registration--input-group">
          <div class="registration--input-section-2">
            <div class="input-group-section-2">
              <div class="form-group">
                <label for="country" tabindex="0">{{
                  state.registrationPage.companyDetails.country
                  }}</label>
                <div class="desktop-view">
                  <mat-select (selectionChange)="updateCountrySelection()" disableOptionCentering
                    panelClass="myPanelClass" yPosition="below" class="form-select" aria-label="country"
                    formControlName="country" [ngClass]="{ 'error-input': validateCompanyDetails('country') }"
                    disableRipple>
                    <mat-option *ngFor="let country of countries" [value]="country.value">
                      {{ country.label }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="mobile-view">
                  <select (change)="updateCountrySelection()" class="form-select" aria-label="country"
                    formControlName="country" [ngClass]="{ 'error-input': validateCompanyDetails('country') }">
                    <option *ngFor="let country of countries" [value]="country.value">
                      {{ country.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="validateCompanyDetails('country')" class="registration--pending error-message" role="alert" tabindex="0">
                {{ getRequiredErrorMessage(state.registrationPage.companyDetails.country) }}
              </div>
            </div>
            <div class="input-group-section-2">
              <div class="form-group">
                <label for="city" tabindex="0">{{
                  state.registrationPage.companyDetails.city
                  }}</label>
                <input [ngClass]="{ 'error-input': validateCompanyDetails('city') }" type="text" id="city" name="city"
                  maxlength="50" formControlName="city"
                  (input)="nonNumericSpaceRestriction(service.companyDetailsForm.controls['city'].value, 'city')"
                  [attr.disabled]="isCompanySectionDisabled()" />
              </div>
              <div *ngIf="validateCompanyDetails('city') && service.companyDetailsForm.controls['city']['errors']" tabindex="0"
                class="registration--pending error-message" role="alert">
                <div *ngIf="service.companyDetailsForm.controls['city']['errors']['required']">
                    {{ getRequiredErrorMessage(state.registrationPage.companyDetails.city) }}
                </div>
                <div *ngIf="service.companyDetailsForm.controls['city']['errors']['alphaSpclCharValidationError']">
                     {{ state.errorText.invalidCharacterWithNumericErrorMessage }}
                </div>
              </div>
            </div>
            <div class="input-group-section-2">
              <div class="form-group">
                <label for="state" tabindex="0">{{
                  state.registrationPage.companyDetails.state
                  }}</label>
                <div class="desktop-view">
                  <mat-select disableOptionCentering panelClass="statePanelClass" yPosition="below" class="form-select"
                    aria-label="state" formControlName="state" [value]="service.companyDetailsForm.controls['state'].value"
                    [ngClass]="{ 'error-input': validateCompanyDetails('state') }" disableRipple>
                    <mat-option *ngFor="let state of statesValue" [value]="state.value">
                      <span class="state-group">{{ state.label }}</span>
                    </mat-option>
                  </mat-select>
                </div>
                <div class="mobile-view">
                  <select id="stateDropdownMobile" class="form-select" aria-label="state" formControlName="state"
                    [ngClass]="{ 'error-input': validateCompanyDetails('state') }">
                    <option *ngFor="let state of statesValue" [value]="state.value">
                      <span class="state-group">{{ state.label }}</span>
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="validateCompanyDetails('state')" class="registration--pending error-message" role="alert" tabindex="0">
                {{ getRequiredErrorMessage(state.registrationPage.companyDetails.state) }}
              </div>
            </div>
            <div class="input-group-section-2 zip-code">
              <div class="form-group">
                <label for="zipCode" tabindex="0">{{
                  state.registrationPage.companyDetails.zipCode
                  }}</label>
                <input [ngClass]="{
                        'error-input': validateCompanyDetails('postalCode')
                      }" type="text" id="zipCode" name="zipCode" maxlength="10" formControlName="postalCode"
                  (input)="inputFormatterCompanyInfo('postalCode')" [attr.disabled]="isCompanySectionDisabled()" />
              </div>
              <div *ngIf="validateCompanyDetails('postalCode')" class="registration--pending error-message" tabindex="0">
                <div *ngIf="
                        service.companyDetailsForm.controls['postalCode'][
                          'errors'
                        ] &&
                        service.companyDetailsForm.controls['postalCode'][
                          'errors'
                        ]['required']
                      " class="registration--pending error-message" role="alert">
                    {{ getRequiredErrorMessage(state.registrationPage.companyDetails.zipCode) }}
                </div>
              </div>
              <div *ngIf="
                      service.companyDetailsForm.controls['postalCode'] &&
                      validateZipCodeLength() &&
                      (service.companyDetailsForm.controls['country']['value'] === 'USA' )
                    " class="registration--pending error-message" role="alert" tabindex="0">
                    {{ state.errorText.minLengthZipCodeError }}
              </div>
              <div
                *ngIf="service.companyDetailsForm.controls['postalCode'] && validateCanadaZipCode() && (service.companyDetailsForm.controls['country']['value'] === 'CAN')"
                class="registration--pending error-message" role="alert" tabindex="0">
                {{ state.errorText.canadaPostalCodeFormatError }}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="registration--section-2-action" >
      <kng-button class="modifyDetailsButton" *ngIf="service.showModifyButton"
       [state]="state.modifyDetailsButton" (clicked)="handleModifyDetailsButtonClick()"></kng-button>
  
      <kng-button class="verifyInformationButton" [state]="state.verifyInformationButton"
        (clicked)="verifyInformation(companyNotFoundContainer)"></kng-button>
    </div>
    <kng-modal-component #confirmVerifiedAddress *ngIf="service.addressSuggestion" [state]="verifyAddressModal" (ctaClickedOn)="proceedWithAddressOrCancel($event, companyNotFoundContainer)" (closed)="verifyAddressModalClosed()">
      <div class="verify-address--modal">
        <div class="">
          <div *ngIf="service.vertexFailedWithNoSuggestedAddress" class="registration--vertexoptionSubhead" tabindex="0">{{ state.mapVertexAddressFailedLabels.description }}
          </div>
          <div *ngIf="!service.vertexFailedWithNoSuggestedAddress" class="registration--vertexoptionSubhead" tabindex="0">{{ state.vertexAPIValidationLabels.description }}
          </div>
          <div *ngIf="service.vertexFailedWithNoSuggestedAddress">
            <div class="registration--radio-btn-section entered-address-modal">
              <span class="user-entered-sub-header">
                {{ state.mapVertexAddressFailedLabels.editAddressLabel }}
              </span>
              <div class="user-entered-address" tabindex="0">
                {{initialAddressInput?.addressLine1}},<br />
                {{initialAddressInput?.city}}, {{initialAddressInput?.state}}, {{initialAddressInput.postalCode}}
              </div>
            </div>
          </div>
          <div *ngIf="!service.vertexFailedWithNoSuggestedAddress">
          <mat-radio-group class="registration--modaloptions" aria-label="Select an option">
            <div class="registration--radio-btn-section">
              <mat-radio-button class="registration--modal-option" value="UseVerifiedAddress"
                (change)="onAddressOptionChange('Use Verified Address')" [checked]="true">
                <span class="wrap-mat-radio-label">
                  {{ state.vertexAPIValidationLabels.useVerifiedLabel }}
                </span>
                
              </mat-radio-button>
              <div class="registration--suggested-address" tabindex="0">
                {{service.verifiedAddress.verifiedLocation?.addressLine1}},<br />
                {{service.verifiedAddress.verifiedLocation?.city}}, {{service.addressState}}, {{service.formattedPostalCode}}
              </div>
            </div>
            <div class="registration--radio-btn-section">
              <mat-radio-button class="registration--modal-option" value="EditAddress"
                (change)="onAddressOptionChange('Edit Address')">
                <span class="wrap-mat-radio-label">
                  {{ state.vertexAPIValidationLabels.editAddressLabel }}
                </span>
              </mat-radio-button>
              <div class="registration--suggested-address" tabindex="0">
                {{initialAddressInput?.addressLine1}},<br />
                {{initialAddressInput?.city}}, {{initialAddressInput?.state}}, {{initialAddressInput.postalCode}}
              </div>
            </div>
          </mat-radio-group>
          </div>
        </div>
      </div>
   </kng-modal-component>
   <kng-modal-component #addressNotVerified *ngIf="showUserInfosNotFound" [state]="companyNotFoundErrorModal" (ctaClickedOn)="submitRegistrationReviewOrCancel($event)" (closed)="submitReviewModalClosed()">
      <div class="verify-address--modal">
        <div class="registration--vertexoptionSubhead m-bt-24" tabindex="0">{{state.registrationPage.companyDetails.companyNotFoundErrorModalDescription}}</div>
      </div>
 </kng-modal-component>
 <kng-modal-component #roleChangeVerify *ngIf="!verifyRoleModal.hidden" [state]="verifyRoleModal" (ctaClickedOn)="verifyRoleModalBtnEvent($event, companyNotFoundContainer)">
  <div class="verify-address--modal roleChangeModal">
        <div>
          <div class="registration--vertexoptionSubhead" tabindex="0">{{ state.mapVerifyRoleLabels.description }}
          </div>
          <div class="roleChangeFormContainer">
          <label for="roleSelect" tabindex="0">
              {{ state.mapVerifyRoleLabels.dropdownLabel }}</label>
          <mat-select name="roleSelect" #verifyRoleChange disableOptionCentering panelClass="myPanelClass" yPosition="below" disableRipple
                  class="form-select verifyChangeRoleDropdown" aria-label="requested role" [disabled]="true" [placeholder]="companyAdminValue">
          </mat-select>
          </div>
        </div>
  </div>
 </kng-modal-component>
  </div>
  